import { useEffect } from "react";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import {
    useForm,
    useFetch,
    useToast,
    usePopup,
    useTheme,
    useStore,
    useGrid,
    useModal,
    useResource,
} from "@/comn/hooks";
import { BASE, APIS, SF_COMN_CD_M_SRCH, SG_COMN_CD_M } from "./services/OsciComnPpupService";
import { ComnCdMVldLst } from "./ComnCdMVldLst";

export const CommonCodeMList = (props: any) => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0088" }],
    });

    const pgeUid = "comnCdMLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); /* * */
    const { theme } = useTheme();

    const form = {
        comnCdMSrch: useForm({
            defaultSchema: SF_COMN_CD_M_SRCH,
            defaultValues:
                { ...pgeStore?.form, comnCd: params?.comnCd || "", langCd: theme.lang.toUpperCase() || "" } || {},
        }),
    };

    const grid = {
        comnCdMLst: useGrid({
            defaultSchema: SG_COMN_CD_M,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getComnCdLst: useFetch({
            api: (page = grid.comnCdMLst.page) => {
                return APIS.getComnCdMLst(form.comnCdMSrch.getValues(), page, grid.comnCdMLst.size);
            },
            enabled: comnUtils.isEmpty(form.comnCdMSrch.errors) && form.comnCdMSrch.isSubmitted,
            key: [grid.comnCdMLst.page, grid.comnCdMLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.comnCdMSrch.getValues(),
                    page: grid.comnCdMLst.page,
                    size: grid.comnCdMLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.comnCdMSrch.handleSubmit(
                () => {
                    grid.comnCdMLst.setPage(0);
                    fetch.getComnCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.comnCdMLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            postMessage({ data: list });
            close();
        },
    };

    const render = {
        grid_ComnCdLst: {
            cell: {
                comnCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <a
                            href="#!"
                            onClick={() => {
                                if (!comnUtils.isPopup()) return;

                                postMessage({ code: rowValues.comnCd, label: rowValues.comnCdNm });
                                close();
                            }}
                        >
                            {value}
                        </a>
                    );
                },
                comnCdVld: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Button
                            type="button"
                            color="success"
                            onClick={() => {
                                modal.openModal({
                                    draggable: true,
                                    size: "sm",
                                    content: (
                                        <ComnCdMVldLst
                                            bsopClsfCd={rowValues.bsopClsfCd}
                                            comnCd={rowValues.comnCd}
                                            comnCdNm={rowValues.comnCdNm}
                                        />
                                    ),
                                });
                            }}
                        >
                            {t("B_DTL")}
                        </Button>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.comnCd) {
            form.comnCdMSrch.setSchema("comnCd", { readOnly: true });
        }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.comnCdMLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page id={pgeUid} title={t("T_COMN_CD_LST")}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.comnCdMSrch.schema.comnCd}></Group.Control>
                                <Group.Control {...form.comnCdMSrch.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.comnCdMSrch.schema.comnCdNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    onClick={() => {
                                        form.comnCdMSrch.reset();
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.comnCdMLst.grid}
                            data={fetch.getComnCdLst.data?.comnCdMList}
                            render={render.grid_ComnCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
